import { DriverAccountOutput } from '@allocab/allocab-driver-shared-types';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { driverApi } from '../services/network/Api';

const fetchAccount = () => driverApi.get<void, DriverAccountOutput>(`/v1/account`);

export const useFetchAccount = () => useQuery(queryKeys.user.fetchAccount(), fetchAccount);
